import { cn } from '@/lib/utils'

/**
 * The small icon + label heading used above home/newsletter/featured sections.
 * The same `<h2>` + icon + `ml-3` span markup was repeated across several
 * components; pass an icon and label instead.
 */
export function SectionHeader({
  icon: Icon,
  label,
  className,
}: {
  icon: React.ComponentType<{ className?: string }>
  label: string
  className?: string
}) {
  return (
    <h2
      className={cn(
        'section-title flex text-sm font-semibold text-zinc-900 dark:text-zinc-100',
        className,
      )}
    >
      <Icon className="size-6 flex-none" />
      <span className="ml-3">{label}</span>
    </h2>
  )
}
